module.exports = __webpack_public_path__ + "img/Tampons-Apaym.ae7cc34e.png";